<div *ngIf="!selectingType" class="flex flex-column h-full">
    <div *ngIf='isLoading' class="flex flex-column align-items-center justify-content-center">
        <h5>{{spinnerMessage}}</h5>
        <p-progressSpinner></p-progressSpinner>
    </div>

    <div *ngIf='!isLoading' class="flex flex-column h-full overflow-hidden">
        <div class="flex-grow-1 overflow-y-auto p-3">
            <form [formGroup]='form' (ngSubmit)="save(documentEditForm.form.value)" #documentEditForm="ngForm" class="flex flex-column h-full">
                <p-tabs [(value)]="activeTabIndex" class="custom-tabs flex flex-column h-full">
                    <p-tablist>
                        <p-tab value="0"><i class="pi pi-id-card mr-2"></i> <span>1. Identificación y Estado</span></p-tab>
                        <p-tab value="1"><i class="pi pi-sliders-h mr-2"></i> <span>2. Medición y Resultados</span></p-tab>
                        <p-tab value="2" *ngIf="!cualitative"><i class="pi pi-calculator mr-2"></i> <span>3. Cálculo y Ecuación</span></p-tab>
                        <p-tab value="3"><i class="pi pi-bookmark mr-2"></i> <span>4. Referencias y Costos</span></p-tab>
                    </p-tablist>

                    <p-tabpanels class="p-3">
                        <!-- TAB 0: IDENTIFICACIÓN Y ESTADO -->
                        <p-tabpanel value="0">
                            <div *ngIf="!selectingAnaliteFromTable" class="flex flex-column gap-4">
                                <!-- Banner informativo -->
                                <div class="surface-50 border-1 border-200 border-round-xl p-3 flex align-items-center justify-content-between flex-wrap gap-2">
                                    <div class="flex align-items-center gap-3">
                                        <i class="pi pi-info-circle text-primary text-2xl"></i>
                                        <div>
                                            <span class="font-bold text-900 text-base">Determinación {{ cualitative ? 'Cualitativa' : 'Cuantitativa' }}</span>
                                            <p class="text-sm text-500 m-0 mt-1 line-height-3">Configure los datos principales de identificación y parámetros de estado para este ensayo.</p>
                                        </div>
                                    </div>
                                    <span [class]="cualitative ? 'bg-orange-50 text-orange-700 border-orange-200' : 'bg-blue-50 text-blue-700 border-blue-200'"
                                        class="px-3 py-1 border-round-xl text-sm font-semibold border-1">
                                        {{ cualitative ? 'Cualitativo' : 'Cuantitativo' }}
                                    </span>
                                </div>

                                <!-- Grid de campos de Identificación -->
                                <div class="grid p-fluid form-inputs-grid">
                                    <!-- Determinación con lupa -->
                                    <div class="col-12 md:col-6 field-item">
                                        <div class="analite-input-group">
                                            <p-floatLabel>
                                                <input pInputText id="analite" type="text" formControlName='analite' readonly
                                                    (click)='openAnaliteOptionsTableDialog()' class="w-full cursor-pointer">
                                                <label for="analite">Determinación <span class="text-red-500">*</span></label>
                                            </p-floatLabel>
                                            <button pButton type="button" icon="pi pi-search" (click)='openAnaliteOptionsTableDialog()'
                                                class="analite-search-btn" pTooltip="Abrir tabla de selección de determinaciones"></button>
                                        </div>
                                        <span class="field-helper">Determinación seleccionada del catálogo general.</span>
                                    </div>

                                    <!-- Referencia importación -->
                                    <div class="col-12 md:col-6 field-item">
                                        <p-floatLabel>
                                            <input pInputText id="importReference" formControlName='importReference' autocomplete="off" class="w-full">
                                            <label for="importReference">Referencia de importación</label>
                                        </p-floatLabel>
                                        <span class="field-helper">Identificador técnico para importación de equipos e interfaces.</span>
                                        <small class="p-error" *ngIf="form.controls.importReference.invalid">{{ getErrorMessage(form.controls.importReference) }}</small>
                                    </div>

                                    <!-- Alias -->
                                    <div class="col-12 md:col-6 field-item">
                                        <p-floatLabel>
                                            <input pInputText id="alias" formControlName='alias' autocomplete="off" class="w-full">
                                            <label for="alias">Alias</label>
                                        </p-floatLabel>
                                        <span class="field-helper">Nombre visible alternativo en informes o consultas internas.</span>
                                        <small class="p-error" *ngIf="form.controls.alias.invalid">{{ getErrorMessage(form.controls.alias) }}</small>
                                    </div>

                                    <!-- Sub grupo (si isBio) -->
                                    <div *ngIf="isBio" class="col-12 md:col-6 field-item">
                                        <p-floatLabel>
                                            <p-autoComplete id="analite_group_name" formControlName="analite_group_name" [suggestions]="filteredGroups"
                                                (completeMethod)="_filterGroups($event.query)" class="w-full" styleClass="w-full"></p-autoComplete>
                                            <label for="analite_group_name">Sub grupo</label>
                                        </p-floatLabel>
                                        <span class="field-helper">Agrupador dentro del ensayo para muestras biológicas.</span>
                                    </div>
                                </div>

                                <p-divider styleClass="my-4"></p-divider>

                                <!-- Sección de Estados con explicaciones -->
                                <div>
                                    <div class="form-section-header">
                                        <div class="form-section-title">Estados y Trazabilidad</div>
                                        <div class="form-section-subtitle">Configure la disponibilidad operativa y atributos de calidad de la determinación.</div>
                                    </div>

                                    <div class="grid" style="row-gap: 1rem;">
                                        <!-- Activo -->
                                        <div class="col-12 md:col-6">
                                            <div class="toggle-card">
                                                <div class="flex flex-column gap-1 pr-2">
                                                    <span class="toggle-card-title">Activo</span>
                                                    <span class="toggle-card-desc">
                                                        Habilita la determinación en el ensayo. Si se desactiva, no se solicitará en nuevas muestras ni en la carga de resultados.
                                                    </span>
                                                </div>
                                                <p-toggleSwitch formControlName='active'></p-toggleSwitch>
                                            </div>
                                        </div>

                                        <!-- Acreditado -->
                                        <div class="col-12 md:col-6">
                                            <div class="toggle-card">
                                                <div class="flex flex-column gap-1 pr-2">
                                                    <span class="toggle-card-title">Acreditado</span>
                                                    <span class="toggle-card-desc">
                                                        Indica si el análisis cuenta con acreditación oficial de calidad (ej. ISO/IEC 17025) bajo este método, identificándose en el informe final emitido al cliente.
                                                    </span>
                                                </div>
                                                <p-toggleSwitch formControlName='accredited'></p-toggleSwitch>
                                            </div>
                                        </div>

                                        <!-- Antecedentes -->
                                        <div class="col-12 md:col-6">
                                            <div class="toggle-card">
                                                <div class="flex flex-column gap-1 pr-2">
                                                    <span class="toggle-card-title">Antecedentes</span>
                                                    <span class="toggle-card-desc">
                                                        Permite consultar y llevar un histórico de trazabilidad con los resultados anteriores de esta determinación para la misma muestra o cliente.
                                                    </span>
                                                </div>
                                                <p-toggleSwitch formControlName='record'></p-toggleSwitch>
                                            </div>
                                        </div>

                                        <!-- Requiere foto (si aplica) -->
                                        <div class="col-12 md:col-6" *ngIf="showFormControl('assay_analite', 'require_picture')">
                                            <div class="toggle-card">
                                                <div class="flex flex-column gap-1 pr-2">
                                                    <span class="toggle-card-title">Requiere foto</span>
                                                    <span class="toggle-card-desc">
                                                        Exige al analista adjuntar una fotografía o evidencia visual como respaldo al momento de cargar el resultado.
                                                    </span>
                                                </div>
                                                <p-toggleSwitch formControlName='require_picture'></p-toggleSwitch>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- VISTA DEDICADA DE SELECCIÓN DE DETERMINACIÓN (DENTRO DE LA PESTAÑA IDENTIFICACIÓN) -->
                            <div *ngIf="selectingAnaliteFromTable" class="surface-card border-round-xl border-1 surface-border overflow-hidden" style="min-height: 520px;">
                                <app-table-select-analite
                                    [title]="'Seleccionar Determinación'"
                                    [subtitle]="'Elija la determinación para este ensayo. Haga doble clic o use el botón Seleccionar para aplicar.'"
                                    [backButtonLabel]="'Volver a los campos'"
                                    (selectAnalite)="onAnaliteSelected($event)"
                                    (cancelSelection)="cancelAnaliteSelection()">
                                </app-table-select-analite>
                            </div>
                        </p-tabpanel>

                        <!-- TAB 1: MEDICIÓN Y RESULTADOS -->
                        <p-tabpanel value="1">
                            <div class="flex flex-column gap-4">
                                <!-- Parámetros de Medición -->
                                <div>
                                    <div class="form-section-header">
                                        <div class="form-section-title">Parámetros de Medición</div>
                                        <div class="form-section-subtitle">Defina la unidad, método analítico y formato del resultado obtenido.</div>
                                    </div>

                                    <!-- Caso Cualitativo -->
                                    <div *ngIf="cualitative" class="grid p-fluid form-inputs-grid">
                                        <div class="col-12 md:col-6 field-item">
                                            <p-floatLabel>
                                                <p-multiSelect id="cualResultOptions" formControlName="cualResultOptions" [options]="cualResultOptions"
                                                    optionLabel="value" optionValue="id" [filter]="true" class="w-full">
                                                    <ng-template let-option pTemplate="item">
                                                        {{ option.value }} - {{ option.code }}
                                                    </ng-template>
                                                </p-multiSelect>
                                                <label for="cualResultOptions">Resultados Cualitativos</label>
                                            </p-floatLabel>
                                            <span class="field-helper">Opciones predefinidas de resultado cualitativo (ej: Positivo, Negativo).</span>
                                        </div>

                                        <div class="col-12 md:col-6 field-item" *ngIf="assay.kind == 'Default'">
                                            <p-floatLabel>
                                                <p-select id="defaultResultCual" formControlName="defaultResult" [options]="cualResultOptions" optionLabel="value"
                                                    optionValue="value" [filter]="true" [showClear]="true" class="w-full">
                                                    <ng-template let-option pTemplate="item">
                                                        {{ option.value }} - {{ option.code }}
                                                    </ng-template>
                                                </p-select>
                                                <label for="defaultResultCual">Resultado por defecto</label>
                                            </p-floatLabel>
                                            <span class="field-helper">Valor precargado automáticamente al registrar un resultado.</span>
                                        </div>
                                    </div>

                                    <!-- Caso Cuantitativo -->
                                    <div *ngIf="!cualitative" class="grid p-fluid form-inputs-grid">
                                        <!-- Unidad -->
                                        <div class="col-12 md:col-4 field-item">
                                            <p-floatLabel>
                                                <p-select id="unit" formControlName='unit' [options]="units" optionLabel="value" optionValue="id"
                                                    [filter]="true" class="w-full">
                                                    <ng-template let-unit pTemplate="item">
                                                        {{ unit.value }} - {{ unit.code }}
                                                    </ng-template>
                                                    <ng-template let-unit pTemplate="selectedItem">
                                                        {{ unit.value }} - {{ unit.code }}
                                                    </ng-template>
                                                    <ng-template #footer>
                                                        <div class="p-2">
                                                            <p-button type="button"
                                                                (click)="buttonConfig('unit', 'FormTechConfig', 'units', 'techConfigs')"
                                                                label="Agregar Unidad" fluid severity="secondary" text size="small" icon="pi pi-plus" />
                                                        </div>
                                                    </ng-template>
                                                </p-select>
                                                <label for="unit">Unidad de medida</label>
                                            </p-floatLabel>
                                            <span class="field-helper">Unidad analítica del resultado (mg/L, %, ppm, etc.).</span>
                                            <small class="p-error" *ngIf="form.controls.unit.invalid">{{ getErrorMessage(form.controls.unit) }}</small>
                                        </div>

                                        <!-- Método -->
                                        <div class="col-12 md:col-4 field-item">
                                            <p-floatLabel>
                                                <p-select id="methodId" formControlName='methodId' [options]="methods" optionLabel="value"
                                                    optionValue="id" [filter]="true" class="w-full">
                                                    <ng-template let-method pTemplate="item">
                                                        {{ method.value }} - {{ method.code }}
                                                    </ng-template>
                                                    <ng-template let-method pTemplate="selectedItem">
                                                        {{ method.value }} - {{ method.code }}
                                                    </ng-template>
                                                    <ng-template #footer>
                                                        <div class="p-2">
                                                            <p-button type="button"
                                                                (click)="buttonConfig('methodId', 'FormTechConfig', 'methods', 'techConfigs')"
                                                                label="Agregar Método" fluid severity="secondary" text size="small" icon="pi pi-plus" />
                                                        </div>
                                                    </ng-template>
                                                </p-select>
                                                <label for="methodId">Método de ensayo</label>
                                            </p-floatLabel>
                                            <span class="field-helper">Técnica o normativa de análisis aplicada.</span>
                                        </div>

                                        <!-- Decimales -->
                                        <div class="col-12 md:col-2 field-item">
                                            <p-floatLabel>
                                                <input pInputText id="decimals" type="number" formControlName='decimals' autocomplete="off" class="w-full">
                                                <label for="decimals">Decimales</label>
                                            </p-floatLabel>
                                            <span class="field-helper">Cifras para redondeo.</span>
                                            <small class="p-error" *ngIf="form.controls.decimals.invalid">{{ getErrorMessage(form.controls.decimals) }}</small>
                                        </div>

                                        <!-- Resultado default Cuantitativo -->
                                        <div class="col-12 md:col-2 field-item" *ngIf="assay.kind == 'Default'">
                                            <p-floatLabel>
                                                <input pInputText id="defaultResult" formControlName='defaultResult' autocomplete="off" class="w-full">
                                                <label for="defaultResult">Default</label>
                                            </p-floatLabel>
                                            <span class="field-helper">Valor sugerido.</span>
                                            <small class="p-error" *ngIf="form.controls.defaultResult.invalid">{{ getErrorMessage(form.controls.defaultResult) }}</small>
                                        </div>
                                    </div>
                                </div>

                                <p-divider styleClass="my-4"></p-divider>

                                <!-- Configuración de Publicación e Informe -->
                                <div>
                                    <div class="form-section-header">
                                        <div class="form-section-title">Comportamiento en Informes y Muestras</div>
                                        <div class="form-section-subtitle">Configure cómo se procesa el resultado frente a otras determinaciones y su visibilidad en el reporte final.</div>
                                    </div>

                                    <!-- Valor a informar (Cuantitativo) -->
                                    <div *ngIf="!cualitative" class="grid p-fluid form-inputs-grid">
                                        <div class="col-12 md:col-6 field-item">
                                            <p-floatLabel>
                                                <p-select id="valueToInform" formControlName='valueToInform' [options]="valueToInformKeys" class="w-full">
                                                    <ng-template let-v pTemplate="item">{{ valueToInformMap.get(v) }}</ng-template>
                                                    <ng-template let-v pTemplate="selectedItem">{{ valueToInformMap.get(v) }}</ng-template>
                                                </p-select>
                                                <label for="valueToInform">Valor a informar en el reporte</label>
                                            </p-floatLabel>
                                            <span class="field-helper">Especifica qué versión del resultado se publica oficialmente (medido crudo, ajustado, etc.).</span>
                                        </div>

                                        <!-- Tipo de humedad si aplica -->
                                        <div *ngIf='showHumidityKind()' class="col-12 md:col-6 field-item">
                                            <p-floatLabel>
                                                <p-select id="humidity_kind" formControlName='humidity_kind' [options]="['PRELIMINAR', 'REMANENT']" class="w-full"></p-select>
                                                <label for="humidity_kind">Tipo de Humedad</label>
                                            </p-floatLabel>
                                            <span class="field-helper">Indica si corresponde a humedad preliminar o remanente.</span>
                                        </div>
                                    </div>

                                    <div class="grid" style="row-gap: 1rem;">
                                        <!-- Informar -->
                                        <div class="col-12 md:col-6">
                                            <div class="toggle-card">
                                                <div class="flex flex-column gap-1 pr-2">
                                                    <span class="toggle-card-title">Informar en reporte final</span>
                                                    <span class="toggle-card-desc">
                                                        Determina si el resultado se imprime en el informe oficial entregado al cliente, o si permanece solo para control interno del laboratorio.
                                                    </span>
                                                </div>
                                                <p-toggleSwitch formControlName='inform'></p-toggleSwitch>
                                            </div>
                                        </div>

                                        <!-- Afecta otros resultados -->
                                        <div class="col-12 md:col-6" *ngIf="!validationBio">
                                            <div class="toggle-card">
                                                <div class="flex flex-column gap-1 pr-2">
                                                    <span class="toggle-card-title">Afecta otros resultados</span>
                                                    <span class="toggle-card-desc">
                                                        Indica si este resultado sirve como insumo matemático o corrección para otras determinaciones del ensayo (ej. corrección por humedad o base seca).
                                                    </span>
                                                </div>
                                                <p-toggleSwitch formControlName='affectResults'></p-toggleSwitch>
                                            </div>
                                        </div>

                                        <!-- Es Afectado por otros resultados -->
                                        <div class="col-12 md:col-6" *ngIf="!validationBio">
                                            <div class="toggle-card">
                                                <div class="flex flex-column gap-1 pr-2">
                                                    <span class="toggle-card-title">Es afectado por otros resultados</span>
                                                    <span class="toggle-card-desc">
                                                        Indica si el resultado final de esta determinación depende de la corrección o cálculo proveniente de otra determinación del ensayo.
                                                    </span>
                                                </div>
                                                <p-toggleSwitch formControlName='affectedResults'></p-toggleSwitch>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </p-tabpanel>

                        <!-- TAB 2: CÁLCULO Y ECUACIÓN -->
                        <p-tabpanel value="2" *ngIf="!cualitative">
                            <div class="flex flex-column gap-4">
                                <!-- Switch Maestro de Calculado -->
                                <div class="surface-50 border-1 border-200 border-round-xl p-3 flex align-items-center justify-content-between gap-4">
                                    <div class="flex flex-column gap-1">
                                        <div class="flex align-items-center gap-2">
                                            <i class="pi pi-calculator text-primary text-xl"></i>
                                            <span class="font-bold text-900 text-base">Determinación Calculada</span>
                                        </div>
                                        <p class="text-sm text-500 m-0 mt-1 line-height-3">
                                            Active esta opción si el resultado no se lee de forma directa de un equipo, sino que se obtiene automáticamente mediante una fórmula matemática a partir de otras determinaciones o variables del ensayo.
                                        </p>
                                    </div>
                                    <p-toggleSwitch formControlName='calculated'></p-toggleSwitch>
                                </div>

                                <!-- Opciones y Editor cuando está calculado activo -->
                                <div *ngIf="showEcuationField" class="flex flex-column gap-4">
                                    <!-- Switches auxiliares de cálculo con explicaciones -->
                                    <div class="grid" style="row-gap: 1rem;">
                                        <!-- Puede descartar -->
                                        <div class="col-12 md:col-4">
                                            <div class="toggle-card">
                                                <div class="flex flex-column gap-1 pr-2">
                                                    <span class="toggle-card-title">Puede descartar</span>
                                                    <span class="toggle-card-desc">
                                                        Permite al analista excluir lecturas atípicas o réplicas sin invalidar el cálculo completo.
                                                    </span>
                                                </div>
                                                <p-toggleSwitch formControlName='canDiscardValues'></p-toggleSwitch>
                                            </div>
                                        </div>

                                        <!-- Usar valores ajustados -->
                                        <div class="col-12 md:col-4">
                                            <div class="toggle-card">
                                                <div class="flex flex-column gap-1 pr-2">
                                                    <span class="toggle-card-title">Usar valores Ajustados</span>
                                                    <span class="toggle-card-desc">
                                                        Calcula la fórmula utilizando los valores corregidos por dilución o recuperación en lugar de la lectura cruda.
                                                    </span>
                                                </div>
                                                <p-toggleSwitch formControlName='useAdjustedResultVariables'></p-toggleSwitch>
                                            </div>
                                        </div>

                                        <!-- Saltar valores NaN -->
                                        <div class="col-12 md:col-4">
                                            <div class="toggle-card">
                                                <div class="flex flex-column gap-1 pr-2">
                                                    <span class="toggle-card-title">Saltar valores NaN</span>
                                                    <span class="toggle-card-desc">
                                                        Omite variables sin valor numérico permitiendo computar el resultado si la ecuación lo soporta.
                                                    </span>
                                                </div>
                                                <p-toggleSwitch formControlName='skipNaN'></p-toggleSwitch>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Editor de Ecuación -->
                                    <div class="surface-card border-1 surface-border border-round-xl p-4 mt-2">
                                        <div class="flex flex-column gap-3">
                                            <div class="field-item">
                                                <div class="flex gap-2 align-items-center">
                                                    <p-floatLabel class="flex-1">
                                                        <input #ecuationInput id="ecuation" (contextmenu)="ecuationInputContextMenu($event)" (input)="validateNumericInput('ecuation', $event)"
                                                            pInputText formControlName='ecuation' autocomplete="off" class="w-full">
                                                        <label for="ecuation">Fórmula / Expresión Matemática</label>
                                                    </p-floatLabel>
                                                    <p-button *ngIf="showEcuationFragmentsButton() || true" icon="pi pi-list"
                                                        (onClick)="openEcuationFragments()" styleClass="p-button-secondary"
                                                        [rounded]="true" [text]="true" pTooltip="Ver fragmentos de ecuación"></p-button>
                                                </div>
                                                <span class="field-helper">Haga clic derecho en el campo para insertar variables o fragmentos.</span>

                                                <!-- Estado de validación -->
                                                <div *ngIf="form.controls?.calculated?.value" class="mt-2">
                                                    <div *ngIf="!form.controls.ecuation_validated.value"
                                                        class="p-2 border-round bg-orange-50 text-orange-700 border-1 border-orange-200 flex align-items-center gap-2 text-sm font-medium">
                                                        <i class="pi pi-exclamation-triangle"></i>
                                                        <span>Se debe validar la ecuación utilizando el validador inferior para poder guardar.</span>
                                                    </div>
                                                    <div *ngIf="form.controls.ecuation_validated.value"
                                                        class="p-2 border-round bg-green-50 text-green-700 border-1 border-green-200 flex align-items-center gap-2 text-sm font-medium">
                                                        <i class="pi pi-verified"></i>
                                                        <span>La ecuación se encuentra validada correctamente.</span>
                                                    </div>
                                                </div>
                                                <small class="p-error block" *ngIf="form.controls.ecuation.invalid">
                                                    {{ getErrorMessage(form.controls.ecuation) }}
                                                </small>
                                            </div>

                                            <!-- Componente Validador de Ecuación -->
                                            <app-equation-validator [equationInput]="form.controls.ecuation.value"
                                                [fragments]="form.controls.ecuationFragments.value"
                                                [initialVariables]="form.controls.ecuation_validation_variables.value"
                                                [initialExpectedResult]="form.controls.ecuation_validation_expected_result.value"
                                                (validationChange)="onEquationValidationChange($event)">
                                            </app-equation-validator>
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="!showEcuationField" class="surface-50 border-1 border-dashed border-300 border-round-xl p-5 text-center text-500">
                                    <i class="pi pi-calculator text-3xl mb-2 text-400"></i>
                                    <div class="font-bold text-base text-800">Determinación directa (no calculada)</div>
                                    <div class="text-sm text-500 mt-1">Si este análisis se obtiene mediante cálculo de fórmulas, active el switch superior.</div>
                                </div>
                            </div>
                        </p-tabpanel>

                        <!-- TAB 3: REFERENCIAS Y COSTOS -->
                        <p-tabpanel value="3">
                            <div class="flex flex-column gap-4">
                                <!-- Costo -->
                                <div>
                                    <div class="form-section-header">
                                        <div class="form-section-title">Costo del Análisis</div>
                                        <div class="form-section-subtitle">Defina el costo unitario de procesamiento para cotizaciones y presupuestos.</div>
                                    </div>
                                    <div class="grid p-fluid form-inputs-grid">
                                        <div class="col-12 md:col-4 field-item">
                                            <p-floatLabel>
                                                <input pInputText id="cost" type="number" formControlName='cost' class="w-full">
                                                <label for="cost">Costo analítico base ({{ currencyConfig.symbol }})</label>
                                            </p-floatLabel>
                                            <span class="field-helper">Costo base asociado a esta determinación en el ensayo.</span>
                                            <small class="p-error" *ngIf="form.controls.cost.invalid">{{ getErrorMessage(form.controls.cost) }}</small>
                                        </div>
                                    </div>
                                </div>

                                <p-divider styleClass="my-4"></p-divider>

                                <!-- Valores de Referencia -->
                                <div>
                                    <div class="form-section-header">
                                        <div class="form-section-title">Valores de Referencia</div>
                                        <div class="form-section-subtitle">Límites o valores normales esperados que acompañan al resultado en el informe del cliente para su interpretación.</div>
                                    </div>

                                    <div class="surface-50 border-1 border-200 border-round-xl p-3">
                                        <div class="flex gap-2 mb-3">
                                            <input pInputText [formControl]="refInput" (keydown.enter)="$event.preventDefault()"
                                                placeholder="Ingrese un valor de referencia (ej: < 10 ppm, Normal: 70 - 110 mg/dL)" class="flex-1">
                                            <p-button (onClick)="addReferenceValue(refInput.value, IndexToEdit)"
                                                [disabled]="disableReferenceValue(refInput.value)"
                                                [icon]="IndexToEdit ? 'pi pi-pencil' : 'pi pi-plus'"
                                                [label]="IndexToEdit ? 'Actualizar' : 'Agregar'"
                                                severity="primary" size="small">
                                            </p-button>
                                            <p-button *ngIf="IndexToEdit || IndexToEdit == 0" (onClick)="cancelEditMode()"
                                                icon="pi pi-times" label="Cancelar" severity="danger" [outlined]="true" size="small">
                                            </p-button>
                                        </div>

                                        <div class="flex flex-wrap gap-2 min-h-3rem align-items-center">
                                            <p-chip *ngFor="let reference of form.controls.referenceValues.value; let i = index"
                                                [label]="reference" [removable]="true" (onRemove)="remove(reference, i)"
                                                (click)="editReference(reference, i)"
                                                styleClass="cursor-pointer hover:surface-200 transition-colors">
                                            </p-chip>
                                            <span *ngIf="!form.controls.referenceValues.value?.length" class="text-sm text-500 italic">
                                                No hay valores de referencia configurados aún. Escriba un valor arriba y presione Agregar.
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <!-- Parámetros Moleculares si assay.kind == 'Molecular' -->
                                <div *ngIf="assay.kind == 'Molecular'">
                                    <p-divider styleClass="my-4"></p-divider>
                                    <div class="form-section-header">
                                        <div class="form-section-title">Parámetros Moleculares</div>
                                        <div class="form-section-subtitle">Configuración específica para ensayos moleculares y diagnóstico genético.</div>
                                    </div>

                                    <div class="grid p-fluid form-inputs-grid">
                                        <div class="col-12 md:col-6 field-item">
                                            <p-floatLabel>
                                                <input pInputText id="test_goal" formControlName='test_goal' autocomplete="off" class="w-full">
                                                <label for="test_goal">Objetivo de la prueba</label>
                                            </p-floatLabel>
                                            <small class="p-error" *ngIf="form.controls.test_goal.invalid">{{ getErrorMessage(form.controls.test_goal) }}</small>
                                        </div>

                                        <div class="col-12 md:col-6 field-item">
                                            <p-floatLabel>
                                                <input pInputText id="input_type" formControlName='input_type' autocomplete="off" class="w-full">
                                                <label for="input_type">Insumo tipo</label>
                                            </p-floatLabel>
                                            <small class="p-error" *ngIf="form.controls.input_type.invalid">{{ getErrorMessage(form.controls.input_type) }}</small>
                                        </div>

                                        <div class="col-12 md:col-6 field-item">
                                            <p-floatLabel>
                                                <input pInputText id="sensitivity" formControlName='sensitivity' autocomplete="off" class="w-full">
                                                <label for="sensitivity">Sensibilidad</label>
                                            </p-floatLabel>
                                            <small class="p-error" *ngIf="form.controls.sensitivity.invalid">{{ getErrorMessage(form.controls.sensitivity) }}</small>
                                        </div>

                                        <div class="col-12 md:col-6 field-item">
                                            <p-floatLabel>
                                                <input pInputText id="specificity" formControlName='specificity' autocomplete="off" class="w-full">
                                                <label for="specificity">Especificidad</label>
                                            </p-floatLabel>
                                            <small class="p-error" *ngIf="form.controls.specificity.invalid">{{ getErrorMessage(form.controls.specificity) }}</small>
                                        </div>

                                        <div class="col-12 field-item">
                                            <p-floatLabel>
                                                <textarea pInputTextarea id="interpretation" formControlName='interpretation' rows="3" class="w-full"></textarea>
                                                <label for="interpretation">Interpretación</label>
                                            </p-floatLabel>
                                            <small class="p-error" *ngIf="form.controls.interpretation.invalid">{{ getErrorMessage(form.controls.interpretation) }}</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </p-tabpanel>
                    </p-tabpanels>
                </p-tabs>

                <p-overlayPanel #op>
                    <div class="flex flex-column gap-2 p-2" style="max-height: 300px; overflow-y: auto;">
                        <ng-container *ngIf="form.get('ecuationFragments').value?.length">
                            <h4 class="m-0 mb-2">Fragmentos</h4>
                            <button pButton *ngFor="let fragment of form.get('ecuationFragments').value"
                                (click)="insertVariable(ecuationInput, fragment.name, cursor, true); op.hide()"
                                [pTooltip]="fragment.importReference" label="{{fragment.name}}"
                                class="p-button-text p-button-sm text-left w-full">
                            </button>
                            <p-divider></p-divider>
                        </ng-container>

                        <h4 class="m-0 mb-2">Variables</h4>
                        <button pButton *ngFor="let analite of importReferenceOptions"
                            (click)="insertVariable(ecuationInput, analite.importReference, cursor); op.hide()"
                            [pTooltip]="analite.importReference"
                            label="{{analite.name}} - {{analite.importReference}}"
                            class="p-button-text p-button-sm text-left w-full">
                        </button>
                        <p *ngIf="!importReferenceOptions.length">Sin opciones</p>
                    </div>
                </p-overlayPanel>
            </form>
        </div>

        <div class="modal-footer flex-none p-3 surface-50 border-top-1 surface-border flex align-items-center justify-content-between">
            <div class="flex align-items-center gap-2">
                <p-button label="Guardar" icon="pi pi-save" (onClick)="documentEditForm.ngSubmit.emit()"
                    [disabled]="disbledSaveButton()" [rounded]="true" severity="primary"></p-button>
                <p-button *ngIf='dataSavedOnDB && showCloneButton()' label="Clonar" icon="pi pi-copy" severity="help"
                    (onClick)="openTableCopyAssayAnalitesConfig()" [disabled]="disbledCloneButton()"
                    pTooltip="Replica configuración en todos los ensayos." [rounded]="true" [outlined]="true"></p-button>
                <p-button label="Cancelar" icon="pi pi-times" severity="secondary" [outlined]="true"
                    (onClick)="closeDialog()" [rounded]="true"></p-button>
            </div>

            <div *ngIf='isSaving' class="flex align-items-center gap-2">
                <p-progressSpinner styleClass="w-2rem h-2rem"></p-progressSpinner>
                <span class="text-sm font-medium text-600">{{spinnerMessage}}</span>
            </div>
        </div>
    </div>
</div>


<div *ngIf="selectingType" class="flex flex-column h-full justify-content-center align-items-center">
    <h3 class="text-center mb-5">Seleccione el tipo de determinación...</h3>
    <div class="flex gap-3 justify-content-center flex-wrap">
        <p-card *ngFor="let type of analiteTypes"
            styleClass="cursor-pointer hover:surface-100 transition-colors transition-duration-300 card-hover-effect"
            [style]="type.style" (click)="selectType({isCualitative: type.isCualitative})">
            <ng-template pTemplate="header">
                <div class="p-3 font-bold text-xl text-center">{{type.title}}</div>
            </ng-template>
            <div class="p-3 flex justify-content-center">
                <img [src]="type.image" [alt]="type.title" class="w-8rem">
            </div>
            <p class="text-center px-3 pb-3">{{type.description}}</p>
        </p-card>
    </div>
</div>

